<template>
	<v-dialog v-model="dialog" width="500">
		<v-card>
			<v-card-title class="headline grey lighten-2" primary-title
				>Factuur {{ type === 'view' ? 'bekijken' : 'versturen' }}</v-card-title
			>

			<v-card-text>
				<v-flex xs8 sm5 v-if="isActive">
					<v-dialog
						ref="menu"
						:close-on-content-click="false"
						v-model="menu"
						transition="scale-transition"
						offset-y
						full-width
						width="290px"
						:return-value.sync="invoiceDate"
					>
						<div class="blue darken-2 dark pl-3 pt-2">
							<h3>Factuur datum</h3>
						</div>
						<v-text-field
							slot="activator"
							label="Factuurdatum"
							v-model="invoiceDateFormatted"
							prepend-icon="event"
							readonly
						></v-text-field>
						<v-date-picker
							v-model="invoiceDate"
							locale="nl"
							@change="
								$refs.menu.save(invoiceDate);
								$refs.invoiceViewer.showPdf(
									reservationId,
									customDate ? invoiceDateFormatted : '',
									isActive
								);
							"
							scrollable
						>
							<v-spacer></v-spacer>
							<v-btn flat color="primary" @click="menu = false"
								>Annuleren</v-btn
							>
						</v-date-picker>
					</v-dialog>
				</v-flex>
				<v-text-field
					label="E-mailadres"
					type="text"
					v-if="type === 'send'"
					v-model="email"
				></v-text-field>
				<invoice-viewer
					:reservationId="reservationId"
					ref="invoiceViewer"
				></invoice-viewer>
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="darken-1" flat @click.native="dialog = false"
					>Sluiten</v-btn
				>
				<v-btn
					color="primary"
					flat
					v-if="type === 'view'"
					@click="viewPreInvoice()"
					>Downloaden</v-btn
				>
				<v-btn
					color="primary"
					flat
					v-if="type === 'send'"
					@click="sendPreInvoice()"
					>Verzenden</v-btn
				>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import * as utils from '@/utils/utils';
import moment from 'moment';
import InvoiceViewer from '@/components/subcomponents/InvoiceViewer';
export default {
	name: 'ViewInvoice',
	components: {
		InvoiceViewer
	},
	data() {
		return {
			dialog: false,
			email: '',
			reservationId: 0,
			reservationNumber: 0,
			invoiceDate: '',
			isActive: true,
			menu: false,
			type: '',
			utils
		};
	},
	props: ['customDate'],
	computed: {
		invoiceDateFormatted() {
			return moment(this.invoiceDate).format('DD-MM-YYYY');
		}
	},
	mounted() {
		this.invoiceDate = moment().format('YYYY-MM-DD');
	},
	watch: {
		dialog(value) {
			if (value) {
				this.$refs.invoiceViewer.showPdf(
					this.reservationId,
					this.customDate ? this.invoiceDateFormatted : '',
					this.isActive
				);
			}
		}
	},
	methods: {
		showDialog(reservation, type, isActiveReservation) {
			this.type = type;
			this.isActive = isActiveReservation;
			this.reservationId = reservation.id;
			this.reservationNumber = reservation.reservationNumber;
			this.email = reservation.username;
			this.dialog = true;
		},
		sendPreInvoice() {
			var self = this;
			this.priceLoading = true;
			utils
				.setData(
					basePath + 'api/reservations/sendPreInvoice/' + this.reservationId,
					{ email: this.email, invoiceDate: this.invoiceDateFormatted }
				)
				.then(function(json) {
					if (json && json.data) {
						window.emitter.$emit('showToastMessage', {
							msg: 'Factuur verzonden.'
						});
					}
					self.dialog = false;
				});
		},
		viewPreInvoice() {
			var self = this;
			utils
				.setData(
					basePath +
						'api/reservations/' +
						(this.isActive ? 'getPreInvoice/' : 'getInvoice/') +
						self.reservationId,
					{ invoiceDate: this.customDate ? this.invoiceDateFormatted : '' }
				)
				.then(function(json) {
					window.location.href =
						basePath +
						'api/downloader/downloadInvoice/' +
						json.data +
						'/' +
						self.reservationNumber +
						'/' +
						(self.isActive ? 'Proforma' : 'Factuur');
				});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/Reservations/ViewInvoice.vue